import { List, Tag, Typography, Space } from "antd";
import { ClockCircleOutlined, PlayCircleOutlined, LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import type { LessonListItem as LessonItem } from "@/api/catalog";

const { Text } = Typography;

interface Props {
  lesson: LessonItem;
  /** Học viên đã đăng ký (ENROLLED/COMPLETED) → mở khoá mọi bài, không hiện "Cần đăng ký". */
  unlocked?: boolean;
}

export function LessonRow({ lesson, unlocked = false }: Props) {
  return (
    <List.Item
      style={{ padding: "12px 16px", borderRadius: 8 }}
      actions={[
        unlocked ? (
          <Tag icon={<PlayCircleOutlined />} color="blue" key="open">
            Vào học
          </Tag>
        ) : lesson.is_preview ? (
          <Tag icon={<PlayCircleOutlined />} color="green" key="preview">
            Xem trước
          </Tag>
        ) : (
          <Tag icon={<LockOutlined />} color="default" key="locked">
            Cần đăng ký
          </Tag>
        ),
      ]}
    >
      <Link
        to={`/lessons/${lesson.slug}`}
        style={{ flex: 1, color: "inherit", textDecoration: "none" }}
      >
        <Space size="middle">
          <Text strong style={{ color: "#7a8499", minWidth: 28, whiteSpace: "nowrap" }}>
            {String(lesson.order).padStart(2, "0")}
          </Text>
          <div>
            <Text strong>{lesson.title}</Text>
            <div style={{ fontSize: 12, color: "#7a8499", marginTop: 2 }}>
              <ClockCircleOutlined /> {lesson.duration_minutes} phút
            </div>
          </div>
        </Space>
      </Link>
    </List.Item>
  );
}
